import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY'
  );
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Configure auth settings
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // Use PKCE flow for better security
  },
});

// Auth helper functions
export const auth = {
  // Get current session
  getSession: () => supabase.auth.getSession(),

  // Get current user
  getUser: () => supabase.auth.getUser(),

  // Sign up with email/password
  signUp: (email: string, password: string, options?: { data?: Record<string, any> }) =>
    supabase.auth.signUp({ email, password, options }),

  // Sign in with email/password
  signInWithPassword: (email: string, password: string) =>
    supabase.auth.signInWithPassword({ email, password }),

  // Sign in with OAuth
  signInWithOAuth: (provider: 'google' | 'github' | 'discord' | 'facebook' | 'apple') =>
    supabase.auth.signInWithOAuth({
      provider,
      options: {
        redirectTo: `${window.location.origin}`,
      },
    }),

  // Sign out
  signOut: () => supabase.auth.signOut(),

  // Listen to auth changes
  onAuthStateChange: (callback: (event: string, session: any) => void) =>
    supabase.auth.onAuthStateChange(callback),
};

export default supabase;
